module.exports = __webpack_public_path__ + "static/media/6-iron.21d37897.png";